export function productHasPhotoAssets(product) {
  return product.assets && product.assets.edges.some(({node: asset}) => {
    return asset.__typename === 'PhotoAsset'
  })
}

export function productHasPurchasedPhotos(product) {
  return product.assets && product.assets.edges.some(({node: asset}) => {
    return asset.__typename === 'PhotoAsset' && asset.state === 'purchased'
  })
}

export function productIsDelivered(product) {
  return ['awaiting_approval', 'delivered'].includes(product.state)
}

export function shouldShowDeliveredPhotos(product) {
  return [
    'awaiting_approval',
    'delivered',
    'partially_delivered',
  ].includes(product.state) && productHasPhotoAssets(product)
}

export const PRODUCT_CATEGORIES = {
  "photo": "Foto",
  "video": "Video",
  "digital": "Digital",
  "plan_drawing": "Plantegning",
  "advertising": "Markedsføring og reklame",
  "other": "Annet"
}